module.exports = __webpack_public_path__ + "documents/aa6671f3b45c42f20a8bc13cc0ba3670.csv";